import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3 from 'web3';

const provider = new WalletConnectProvider({
    infuraId: process.env.REACT_APP_INFURA_ID,
    qrcode: false,
});
export const web3 = new Web3(provider);
export default provider
